import { QueryClient } from '@tanstack/react-query';

import { ApiError } from '@/lib/api';

/**
 * TanStack Query defaults (05 §5.1).
 *
 * `retry: 1` for queries, `0` for mutations — a mutation that failed with a
 * domain error (409/422) must never be replayed, and the ones that failed with a
 * network error are re-driven by the user, not silently.
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        gcTime: 5 * 60_000,
        refetchOnWindowFocus: true,
        retry: (failureCount, error) => {
          // Never retry a decided answer from the server: only transport failures.
          if (error instanceof ApiError && !error.isNetworkError) return false;
          return failureCount < 1;
        },
      },
      mutations: {
        retry: 0,
      },
    },
  });
}
